<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalEditarNivel">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title" v-if="folder.operation == 'STORE'"><i class="fa fa-plus-circle"></i> Nova
                        Pasta em
                        <b>{{folder.parentText}}</b></p>
                    <p class="modal-title" v-if="folder.operation == 'UPDATE'">Editar Pasta <b>{{folder.parentText}}</b>
                    </p>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <required /> <label :class="{ 'text-danger': errors.has('Nome') }">Nome</label>
                                <input @keyup.enter="saveFolder()" v-model="folder.title" :class="{ 'is-invalid': errors.has('Nome') }" name="Nome" v-validate="{required: true}" id="Nome"
                                    :placeholder="$t('words.type_description')" class="form-control">
                                <div class="invalid-feedback help-block error">{{errors.first('Nome')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" @click="saveFolder()" :disabled="loading"
                        class="btn btn-success float-right"><i class="fa fa-check"></i>
                        {{$t('words.save')}} <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                folder: {
                    operation: 'STORE',
                    parent: null,
                    id: null,
                    title: null,
                    children: []
                }
            }
        },
        methods: {
            saveFolder() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        let rx = /[<>:"\/\\|?*\x00-\x1F]|^(?:aux|con|clock\$|nul|prn|com[1-9]|lpt[1-9])$/i;
                        if (rx.test(this.folder.title)) {
                            toastr({
                                icon: 'error',
                                title: 'Pasta com caracter inválido!'
                            });
                            return
                        }
                        switch (this.folder.operation) {
                            case 'STORE':
                                this.addLevel();
                                break;
                            case 'UPDATE':
                                this.editLevel();
                                break;
                            case 'DELETE':
                                this.destroyLevel();
                                break;
                        }
                    }
                });
            },
            addLevel() {
                this.loading = true;
                this.$store.dispatch('storeNivel', this.folder).then(response => {
                    this.loading = false;
                    if (response.status && response.status == 'error') {
                        toastr({
                            icon: 'error',
                            title: response.message
                        });
                        return;
                    }
                    toastr({
                        icon: 'success',
                        title: 'Pasta adicionada!'
                    });
                    this.$store.dispatch('getUserData').then(response => {
                        this.$emit('updateData');
                    });
                    $('#ModalEditarNivel').modal('toggle');
                });
            },
            editLevel() {
                this.loading = true;
                this.$store.dispatch('updateNivel', this.folder).then(response => {
                    this.loading = false;
                    if (response.status && response.status == 'error') {
                        toastr({
                            icon: 'error',
                            title: response.message
                        });
                        return;
                    }
                    toastr({
                        icon: 'success',
                        title: 'Atualizado com sucesso!'
                    });
                    this.$store.dispatch('getUserData').then(response => {
                        this.$emit('updateData');
                    });
                    $('#ModalEditarNivel').modal('toggle');
                });
            },
            destroyLevel2() {
                this.loading = true;
                this.$store.dispatch('deleteNivel', this.folder).then(response => {
                    console.log(response)
                    this.loading = false;
                    if (response.status && response.status == 'error') {
                        toastr({
                            icon: 'error',
                            title: response.message
                        });
                        return;
                    }
                    toastr({
                        icon: 'success',
                        title: 'Pasta removida!'
                    });
                    this.$store.dispatch('getUserData').then(response => {
                        this.$emit('updateData');
                    });
                    $('#ModalEditarNivel').modal('toggle');
                });
                //var res = this.flatFilter('children', 'id', this.selectedLevel.id, this.nestableItems);
                // this.nestableItems = res;
            },
            destroyLevel() {
                 Swal.fire({
                    title: trans('words.atention'),
                    html: `Deletando a pasta <b>${this.folder.title}</b><br>
          <small> OBS: Confirmando, sua pasta será deletada <b>permanentemente.</b></small>`,
                    icon: 'warning',
                    input: 'text',
                    inputPlaceholder: 'Digite CONFIRMA para continuar',
                    showCancelButton: true,
                    allowOutsideClick: true,
                    cancelButtonText: trans('words.close'),
                    confirmButtonText: 'Confirmar',
                    confirmButtonClass: 'btn btn-danger btn-lg float-right',
                    cancelButtonClass: 'btn btn-default btn-lg float-left',
                    buttonsStyling: false,
                    reverseButtons: true,
                    showLoaderOnConfirm: true,
                    inputValidator: (value) => {
                        return new Promise((resolve) => {
                            if (value !== 'CONFIRMA') {
                                resolve('Por favor, digite a palavra `CONFIRMA` para continuar');
                            } else {
                                resolve();
                            }
                        });
                    },
                    preConfirm: (confirm) => {
                        return this.$store.dispatch('deleteNivel', this.folder);
                    }
                }).then(response => {
                    if (response.dismiss) {
                        return;
                    }
                    console.log(response);
                    switch (response.value.status) {
                        case 'success':
                             Swal.fire({
                                icon: 'success',
                                title: 'Exclusão de Pasta',
                                html: response.value.message,
                                showCancelButton: true,
                                confirmButtonClass: 'btn btn-default btn-lg float-right',
                                cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                                buttonsStyling: false,
                                confirmButtonText: trans('words.close'),
                                reverseButtons: true
                            });
                            this.$store.dispatch('getUserData').then(response => {
                                this.$emit('updateData');
                            });
                            break;
                        default:
                             Swal.fire({
                                icon: response.value.status,
                                title: 'Exclusão de Pasta',
                                html: response.value.message,
                                showCancelButton: true,
                                allowOutsideClick: true,
                                cancelButtonText: trans('words.close'),
                                confirmButtonText: trans('words.close'),
                                confirmButtonClass: 'btn btn-default btn-lg float-right',
                                cancelButtonClass: 'btn btn-default btn-lg float-left invisible',
                                buttonsStyling: false,
                                reverseButtons: true
                            });
                            break;
                    }
                });
            },
        }
    }
</script>